/* unplugin-vue-components disabled */import { render } from "./IdeTable.vue?vue&type=template&id=b197db3c"
import script from "./IdeTable.vue?vue&type=script&lang=js"
export * from "./IdeTable.vue?vue&type=script&lang=js"

import "./IdeTable.vue?vue&type=style&index=0&id=b197db3c&lang=scss"

import exportComponent from "D:\\Project\\Juanfu\\hcontrol_download\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__